<script setup lang="ts">
import InteractionEventList from "@/components/interaction-review/InteractionEventList.vue";
import { useInteractive } from "@/stores/interactive";
const interactiveStore = useInteractive();
</script>
<template>
  <div class="h-full w-full grid grid-[auto_1fr]">
    <ThreadsNav class="bg-base-100/30" show-back>
      <template #center>
        <div>{{ $t("Buttons.interactionLog") }}</div>
      </template>
    </ThreadsNav>
    <InteractionEventList
      class="h-full overflow-hidden"
      ref="eventListRef"
      enable-pull-load
      @reload="interactiveStore.getPoolList()"
    />
  </div>
</template>
